import React from "react";
import PropTypes from "prop-types";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import styles from "./styles/email-receipt-data.css.js";
import withStyles from "components/with-styles";
import { TextDisplay } from "components/display-data";
import { PageSection } from "components/page";

const EmailReceipt = ({ email, intl, classes, locale }) => (
  <PageSection subsection className={classes.email} spaced>
    <DataGrid>
      <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "event.emailReceipt.email" })}>{email}</TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "event.emailReceipt.locale" })}>
          {intl.formatMessage({ id: `common.language.in.${locale}` })}
        </TextDisplay>
      </DataGridItem>
    </DataGrid>
  </PageSection>
);

EmailReceipt.propTypes = {
  /**
   * Data to represent
   **/
  email: PropTypes.string,
  /**
   * Locale
   **/
  locale: PropTypes.string,
};

const StyledI18nEmailReceipt = withStyles(styles)(injectIntl(EmailReceipt));

const EmailReceiptData = ({ emails, locales }) => {
  const hasEmails = emails && emails.length > 0;

  if (!hasEmails) {
    return null;
  }

  return (
    <DataGrid>
      {emails.map((email, i) => (
        <StyledI18nEmailReceipt key={email} locale={locales[i]} email={email} />
      ))}
    </DataGrid>
  );
};

EmailReceiptData.propTypes = {
  /**
   * Data to represent
   **/
  emails: PropTypes.arrayOf(PropTypes.string),
  /**
   * Data to represent
   **/
  locales: PropTypes.arrayOf(PropTypes.string),
};

export default EmailReceiptData;
